import { LifecycleEnv, RuntimeTelemetryContext } from './types';

const NORMALIZATION_MAP: Record<string, LifecycleEnv> = {
  sandbox: 'sandbox',
  dev: 'dev',
  development: 'dev',
  qa: 'qa',
  test: 'qa',
  stg: 'stg',
  stage: 'stg',
  staging: 'stg',
  pre: 'pre',
  preprod: 'pre',
  'pre-prod': 'pre',
  'pre-us': 'pre',
  prod: 'prod',
  production: 'prod',
};

export const normalizeLifecycleEnv = (rawEnv: string | undefined | null): LifecycleEnv => {
  if (!rawEnv) return 'dev';

  const normalized = rawEnv.toLowerCase().trim().replace(/_/g, '-');
  return NORMALIZATION_MAP[normalized] || 'dev';
};

export const buildRuntimeContext = (
  rawEnv: string | undefined,
  host: string,
  region?: RuntimeTelemetryContext['region']
): RuntimeTelemetryContext => {
  return {
    env: normalizeLifecycleEnv(rawEnv),
    region,
    rawHost: host,
  };
};
